import JSZip from "jszip";
import FileSaver from "file-saver";

export const BatchDownloadFile = {
  data(){
    return {
      fileList:[],
      blogTitle:''
    }
  },
  created(){

  },
  methods:{
    //批量下载文件
    batchDownload() {
      var blogTitle = this.blogTitle;
      var zip = new JSZip();
      var promises = [];
      let cache = {};
      for (let item of this.fileList) {
        // item.url为文件链接地址
        // item.originalName为文件名称
        if (item.url) {
          const promise = this.getImgArrayBuffer(item.url).then((data) => {
            // 下载文件, 并存成ArrayBuffer对象(blob)
            zip.file(item.originalName, data, { binary: true }); // 逐个添加文件
            cache[item.originalName] = data;
          });
          promises.push(promise);
        } else {
          // url地址不存在时提示
          this.$message.error(`附件${item.originalName}地址错误，下载失败`);
          console.log(`附件${item.originalName}地址错误，下载失败`);
        }
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            // 生成二进制流
            FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  blogTitle:自定义文件名
          });
        })
        .catch((res) => {
          this.$message.error("文件压缩失败");
        });
    },
    //文件以流的形式获取（参数url为文件链接地址）
    getImgArrayBuffer(url) {
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (xmlhttp.status == 200) {
            resolve(xmlhttp.response);
          } else {
            reject(xmlhttp.response);
          }
        };
        xmlhttp.send();
      });
    }
  }
}
